import { axiosGet } from "../../Helpers";

export const loadIndustries = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("industry/listIndustry");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
